export const JWT_STORAGE_KEY = 'jwt_access_token';
export const JWT_REFRESH_STORAGE_KEY = 'jwt_refresh_token';
